import { useEffect, useRef, useState } from 'react';

const SERVICES = [
  'Cilt Bakımı',
  'Lazer Epilasyon',
  'Dudak Renklendirme',
  'G5 Sıkılaşma',
  'VIP Paket',
  'Diğer',
];

export default function ContactSection() {
  const [visible, setVisible] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '', service: '', date: '', note: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === 'note') {
      if (value.length > 500) return;
      setCharCount(value.length);
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.phone.trim() || !formData.service) return;
    setLoading(true);
    try {
      const body = new URLSearchParams();
      body.append('name', formData.name);
      body.append('phone', formData.phone);
      body.append('service', formData.service);
      body.append('date', formData.date);
      body.append('note', formData.note);
      await fetch('https://readdy.ai/api/form/d781uaprcamcd36das0g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="iletisim" className="relative py-24 md:py-32 bg-[#0d1117] overflow-hidden">
      {/* Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-[#d4af37]/8 rounded-full blur-[120px] pointer-events-none" />

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="inline-block text-[#d4af37] text-xs font-bold uppercase tracking-[4px] mb-4">
            Randevu Al
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-white leading-tight mb-4">
            Güzelliğiniz İçin{' '}
            <span style={{ background: 'linear-gradient(135deg, #d4af37, #f4d03f)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Yerinizi Ayırtın
            </span>
          </h2>
          <p className="text-white/50 text-base max-w-xl mx-auto">
            Hizmet seçin, uygun tarihi belirtin — uzmanlarımız sizi arasın ve randevunuzu onaylasın
          </p>
        </div>

        {/* Platform açıklama banner */}
        <div
          className="relative mb-12 rounded-2xl border border-[#00d9ff]/20 overflow-hidden"
          style={{ background: 'rgba(0,217,255,0.04)', backdropFilter: 'blur(20px)' }}
        >
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#00d9ff] to-[#d4af37]" />
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 px-6 py-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#00d9ff]/10 shrink-0">
              <i className="ri-information-line text-xl text-[#00d9ff]"></i>
            </div>
            <div className="flex-1">
              <p className="text-white/80 text-sm leading-relaxed">
                <span className="text-white font-semibold">Müşterileriniz</span> aşağıdaki form aracılığıyla randevu taleplerini size iletebilecekler ve siz bu talepleri{' '}
                <span className="text-[#d4af37] font-semibold">yönetim panelinizden interaktif olarak</span> takip edip yönetebileceksiniz.
              </p>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/20 shrink-0">
              <span className="w-2 h-2 flex items-center justify-center">
                <span className="block w-2 h-2 rounded-full bg-[#d4af37] animate-pulse" />
              </span>
              <span className="text-[#d4af37] text-xs font-bold whitespace-nowrap">Canlı Takip</span>
            </div>
          </div>
        </div>

        <div
          className={`grid grid-cols-1 lg:grid-cols-5 gap-8 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Info */}
          <div className="lg:col-span-2 flex flex-col gap-5">
            {[
              { icon: 'ri-map-pin-2-line', title: 'Adres', val: 'Bağcılar Mah. Güzellik Cad. No:42, İstanbul' },
              { icon: 'ri-phone-line', title: 'Telefon', val: '+90 500 123 45 67' },
              { icon: 'ri-time-line', title: 'Çalışma Saatleri', val: 'Pzt–Cmt: 09:00–20:00' },
              { icon: 'ri-instagram-line', title: 'Instagram', val: '@novaguzelliklounge' },
            ].map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-4 p-5 rounded-2xl border border-white/10 hover:border-[#d4af37]/30 transition-all duration-300"
                style={{ background: 'rgba(26,26,46,0.6)', backdropFilter: 'blur(20px)' }}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#d4af37]/10 shrink-0">
                  <i className={`${item.icon} text-xl text-[#d4af37]`}></i>
                </div>
                <div>
                  <div className="text-white/40 text-xs uppercase tracking-widest mb-1">{item.title}</div>
                  <div className="text-white text-sm font-medium">{item.val}</div>
                </div>
              </div>
            ))}

            {/* Hizmetler özet */}
            <div
              className="p-5 rounded-2xl border border-[#d4af37]/20"
              style={{ background: 'rgba(212,175,55,0.05)', backdropFilter: 'blur(20px)' }}
            >
              <div className="text-[#d4af37] text-xs font-bold uppercase tracking-widest mb-3">Hizmetlerimiz</div>
              <div className="flex flex-wrap gap-2">
                {SERVICES.filter(s => s !== 'Diğer').map((s, i) => (
                  <span key={i} className="px-3 py-1 rounded-full bg-white/5 border border-white/10 text-white/60 text-xs">
                    {s}
                  </span>
                ))}
              </div>
            </div>

            {/* WhatsApp CTA */}
            <a
              href="https://wa.me/905001234567?text=Merhaba%2C%20randevu%20almak%20istiyorum."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 py-4 rounded-2xl bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold text-base hover:scale-[1.02] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp&apos;tan Randevu Al
            </a>
          </div>

          {/* Form */}
          <div className="lg:col-span-3">
            <div
              className="rounded-3xl p-8 border border-white/10 h-full"
              style={{ background: 'rgba(26,26,46,0.7)', backdropFilter: 'blur(30px)' }}
            >
              {!submitted ? (
                <form
                  data-readdy-form
                  id="iletisim-form"
                  onSubmit={handleSubmit}
                  className="flex flex-col gap-5 h-full"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="relative">
                      <i className="ri-user-line absolute left-4 top-1/2 -translate-y-1/2 text-white/30 text-sm"></i>
                      <input
                        type="text"
                        name="name"
                        placeholder="Ad Soyad"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full h-12 pl-10 pr-4 rounded-xl bg-white/5 border border-white/10 focus:border-[#d4af37]/60 text-white text-sm placeholder-white/30 outline-none transition-colors"
                      />
                    </div>
                    <div className="relative">
                      <i className="ri-phone-line absolute left-4 top-1/2 -translate-y-1/2 text-white/30 text-sm"></i>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Telefon Numarası"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full h-12 pl-10 pr-4 rounded-xl bg-white/5 border border-white/10 focus:border-[#d4af37]/60 text-white text-sm placeholder-white/30 outline-none transition-colors"
                      />
                    </div>
                  </div>

                  {/* Hizmet seçimi */}
                  <div className="relative">
                    <i className="ri-scissors-2-line absolute left-4 top-1/2 -translate-y-1/2 text-white/30 text-sm pointer-events-none"></i>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      className="w-full h-12 pl-10 pr-4 rounded-xl bg-white/5 border border-white/10 focus:border-[#d4af37]/60 text-sm outline-none transition-colors appearance-none cursor-pointer"
                      style={{ color: formData.service ? '#fff' : 'rgba(255,255,255,0.3)' }}
                    >
                      <option value="" disabled style={{ background: '#0d1117', color: 'rgba(255,255,255,0.4)' }}>
                        Hangi hizmeti almak istiyorsunuz?
                      </option>
                      {SERVICES.map((s) => (
                        <option key={s} value={s} style={{ background: '#0d1117', color: '#fff' }}>
                          {s}
                        </option>
                      ))}
                    </select>
                    <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-white/30 text-sm pointer-events-none"></i>
                  </div>

                  {/* Tarih tercihi */}
                  <div className="relative">
                    <i className="ri-calendar-line absolute left-4 top-1/2 -translate-y-1/2 text-white/30 text-sm pointer-events-none"></i>
                    <input
                      type="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      min={new Date().toISOString().split('T')[0]}
                      className="w-full h-12 pl-10 pr-4 rounded-xl bg-white/5 border border-white/10 focus:border-[#d4af37]/60 text-white text-sm outline-none transition-colors cursor-pointer"
                      style={{ colorScheme: 'dark' }}
                    />
                  </div>

                  {/* Not */}
                  <div className="relative flex-1">
                    <textarea
                      name="note"
                      placeholder="Eklemek istediğiniz bir not var mı? (isteğe bağlı)"
                      value={formData.note}
                      onChange={handleChange}
                      maxLength={500}
                      rows={4}
                      className="w-full p-4 rounded-xl bg-white/5 border border-white/10 focus:border-[#d4af37]/60 text-white text-sm placeholder-white/30 outline-none transition-colors resize-none"
                    />
                    <span className="absolute bottom-3 right-3 text-white/20 text-xs">{charCount}/500</span>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full h-14 rounded-xl bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-black text-base hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(212,175,55,0.3)] transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-70 flex items-center justify-center gap-2"
                  >
                    <i className="ri-calendar-check-line text-lg"></i>
                    {loading ? 'Gönderiliyor...' : 'Randevu Talebi Gönder'}
                  </button>

                  <p className="text-center text-white/25 text-xs">
                    Talebiniz alındıktan sonra ekibimiz sizi arayarak randevunuzu onaylayacaktır.
                  </p>
                </form>
              ) : (
                <div className="flex flex-col items-center justify-center h-full py-12 text-center">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-green-400/15 mb-4">
                    <i className="ri-check-double-line text-3xl text-green-400"></i>
                  </div>
                  <h3 className="text-white font-black text-xl mb-2">Randevu Talebiniz Alındı!</h3>
                  <p className="text-white/50 text-sm max-w-xs">
                    Uzmanlarımız en kısa sürede sizi arayarak randevunuzu onaylayacak. Teşekkür ederiz.
                  </p>
                  <div className="mt-6 flex items-center gap-2 px-4 py-2 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/20">
                    <i className="ri-star-line text-[#d4af37] text-sm"></i>
                    <span className="text-[#d4af37] text-xs font-medium">Nova Güzellik Lounge&apos;a hoş geldiniz</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
